module.exports = __webpack_public_path__ + "img/file_deleted.58e7458c.svg";